import { Row, Col, Button } from "antd";
import { useHistory } from "react-router-dom";

import metaData from "../../data/metaData";

const Header = ({ step, nextLabel = "Next", loading = false, onBack, onNext }) => {
  const history = useHistory();

  return (
    <Row
      justify="space-between"
      align="middle"
      style={{
        width: "100%",
        position: "sticky",
        top: 0,
        padding: "1rem",
      }}
    >
      <Col>
        <img
          style={{
            width: "50px",
            height: "50px",
            borderRadius: "5px",
          }}
          src={metaData.blobPreURL + metaData.appLogoPath + metaData.blobPostURL}
          onClick={() => {
            history.push("/");
          }}
        />
      </Col>
      <Col>
        {step !== 1 ? (
          <Button
            size="large"
            type="ghost"
            loading={loading}
            style={{ width: "7.5rem", marginRight: "2rem" }}
            onClick={() => {
              onBack();
            }}
          >
            Back
          </Button>
        ) : null}

        <Button
          size="large"
          type="primary"
          style={{ width: "7.5rem" }}
          loading={loading}
          onClick={() => {
            onNext();
          }}
        >
          {nextLabel}
        </Button>
      </Col>
    </Row>
  );
};

export default Header;
